export default "__VITE_ASSET__5d6Jptsd__"